import { render } from "./CompetitionsPage.vue?vue&type=template&id=656fe164&scoped=true"
import script from "./CompetitionsPage.vue?vue&type=script&lang=js"
export * from "./CompetitionsPage.vue?vue&type=script&lang=js"

import "./CompetitionsPage.vue?vue&type=style&index=0&id=656fe164&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656fe164"]])

export default __exports__